import ApiHook from './axiosAPI'

const { apiGET, apiPOST, apiPUT } = ApiHook()

const TorneioAPI = {
  // GET: /torneio/buscarTorneioPorId
  BuscarTorneioPorId: async query => {
    const url = `/torneio/buscarTorneioPorId/?idtorneio=${query.idtorneio}&buscarEsportes=true&buscarEquipes=true&buscarEmpresa=${query.buscarEmpresa}`
    const req = await apiGET(url)
    return req
  },

  // GET: /torneio/buscarTorneiosPorCidade
  BuscarTorneiosPorCidade: async cidade => {
    const url = `/torneio/buscarTorneiosPorCidade/?cidade=${cidade}`
    const req = await apiGET(url)
    return req
  },

  // GET: /torneio/buscarTorneiosPorEmpresa
  BuscarTorneiosPorEmpresa: async empresa => {
    const url = `/torneio/buscarTorneiosPorEmpresa/?empresa=${empresa}`
    const req = await apiGET(url)
    return req
  },

  // POST: /torneio/criarEquipe
  CriarEquipe: async data => {
    const url = `/torneio/criarEquipe`
    const req = await apiPOST(url, data)
    return req
  },

  // PUT: /torneio/atualizarEquipe
  AtualizarEquipe: async data => {
    const url = `/torneio/atualizarEquipe`
    const req = await apiPUT(url, data)
    return req
  },

  // POST: /torneio/inscreverEquipe
  InscreverEquipe: async data => {
    const url = `/torneio/inscreverEquipe`
    const req = await apiPOST(url, data)
    return req
  },

  // GET: /torneio/buscarEquipePorId
  BuscarEquipePorId: async id => {
    const url = `/torneio/buscarEquipePorId/?id=${id}`
    const req = await apiGET(url)
    return req
  },

  // GET: /torneio/buscarEquipePorIdTorneio
  BuscarEquipePorIdTorneio: async id => {
    const url = `/torneio/buscarEquipePorIdTorneio/?idtorneio=${id}&buscarUsuarios=true`
    const req = await apiGET(url)
    return req
  },

  // POST: /torneio/atualizarFotoEquipe
  AtualizarFotoEquipe: async data => {
    const url = `/torneio/atualizarFotoEquipe`
    const req = await apiPOST(url, data)
    return req
  },
}

export default TorneioAPI
